export const itemTemplate = (option) => {
    return (
        <div className="country-item">
            <div>{option.name}</div>
        </div>
    );
}

export const panelFooterTemplate = (multiselectValue) => {
    const length = multiselectValue ? multiselectValue.length : 0;
    return (
        <div className="p-py-2 p-px-3">
            <b>{length}</b> เลือกทั้งหมด {length > 1 ? 's' : ''} รายการ.
        </div>
    );
}

export const selectedItemsLabel = 'เลือกทั้งหมด {0} รายการ';
